(function () {
  'use strict';

  var SELECTOR = [
    'button',
    'input[type="submit"]',
    'input[type="button"]',
    'a[role="button"]',
    '.button',
    '.btn',
    '.cta',
    '.shopify-payment-button__button',
    '.shopify-payment-button button',
    '[data-add-to-cart]',
    '.add-to-cart-button',
    '.quick-add__button',
    '.cart__checkout-button',
    '.contact-submit-btn'
  ].join(', ');

  function applyMetaPixBtnClass(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;

    if (scope.matches && scope.matches(SELECTOR)) {
      if (!scope.classList.contains('metapixbtn')) {
        scope.classList.add('metapixbtn');
      }
    }

    var elements = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!el.classList.contains('metapixbtn')) {
        el.classList.add('metapixbtn');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyMetaPixBtnClass(document);
    });
  } else {
    applyMetaPixBtnClass(document);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'childList') {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType === 1) {
            applyMetaPixBtnClass(node);
          }
        }
      } else if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (mutation.target.nodeType === 1 && mutation.target.matches && mutation.target.matches(SELECTOR)) {
          if (!mutation.target.classList.contains('metapixbtn')) {
            mutation.target.classList.add('metapixbtn');
          }
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
})();
